import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const searchMcqs = async (keyword, numberOfQuestions = null) => {
  try {
    const payload = {
      keywords: [keyword],
    };
    const access_token = localStorage.getItem('access_token');
    const queryParam = numberOfQuestions ? `?num_of_results=${numberOfQuestions}` : '';
    const response = await axios.post(`${API_BASE_URL}mcqs/search_rag${queryParam}`, payload, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
   
    return response.data;
  } catch (error) {
    console.error('Error fetching MCQs:', error);
    throw error;
  }
};

export default searchMcqs; 